import React from "react";
import { List, Skeleton, Col, Row } from "antd";
import styled from "styled-components";
import { Address } from "../../../lib/model/Address";

const BigLabel = styled.span`
  font-size: 14px;
  font-weight: 300;
  color: #061a32;
`;

const MediumLabel = styled.span`
  font-size: 11px;
  font-weight: 300;
  color: #061a32;
`;

type Props = {
  isPlaceholder: boolean;
  address?: Address;
};

export const AddressCell: React.FC<Props> = props => {
  const { address, isPlaceholder } = props;
  return (
    <List.Item style={{ padding: 0 }}>
      <Row
        type="flex"
        style={{
          width: "100%",
          padding: "23px 0",
          border: "1px solid #e8e8e8",
          marginBottom: 15
        }}
        align="middle"
      >
        <Skeleton title={false} loading={isPlaceholder} active>
          {address && (
            <>
              <Col
                span={7}
                style={{
                  borderRight: "1px solid #e8e8e8",
                  paddingLeft: 23,
                  paddingRight: 10
                }}
              >
                <BigLabel>{address.companyName}</BigLabel>
              </Col>
              <Col
                span={6}
                style={{
                  padding: "0 30px"
                }}
              >
                <MediumLabel>
                  {address.street} {address.houseNumber}
                  <br />
                  {address.zipCode} {address.city}
                </MediumLabel>
              </Col>
              <Col
                span={6}
                style={{
                  padding: "0 30px"
                }}
              >
                <MediumLabel>
                  {!address.contactName && !address.contactPhone ? "–" : ""}
                  {address.contactName}
                  <br />
                  {address.contactPhone ? `Tel.: ${address.contactPhone}` : ""}
                </MediumLabel>
              </Col>
              <Col
                span={5}
                style={{
                  padding: "0 30px"
                }}
              >
                <MediumLabel>{address.extraInfo || "–"}</MediumLabel>
              </Col>
            </>
          )}
        </Skeleton>
      </Row>
    </List.Item>
  );
};
